export default __webpack_public_path__ + "static/media/bg-menu.7027730b.svg";